import { IconButton, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import Iconify from '../../../fl-components/Iconify';
import TimePicker from './TimePicker';
import TimeNotation from './TimeNotation';

/**
 * TimeRow Component
 *
 * @props {object} slot - Current timing slot
 * @props {boolean} removeBtn - To display remove button
 * @props {function} addSlot - To add new slot in current day
 * @props {function} removeSlot - To remove any slot
 * @props {function} showAddBtn - Display add button
 * @props {function} updateSlot - Handle update from or to timing
 * @props {array} otherSelectedFromTime, otherSelectedToTime - These are the array of times which is previously selected by other slot / In simple language occupied time.
 */
export default function TimeRow({
  slot,
  removeBtn = false,
  addSlot,
  removeSlot,
  showAddBtn,
  updateSlot,
  otherSelectedFromTime,
  otherSelectedToTime
}) {
  const [fromAbbr, setFromAbbr] = useState(moment(slot.from).format('a'));
  const [toAbbr, setToAbbr] = useState(moment(slot.to).format('a'));

  useEffect(() => {
    handleFromTime(slot.from);
  }, [fromAbbr]);

  useEffect(() => {
    handleToTime(slot.to);
  }, [toAbbr]);

  const handleFromTime = (dateIso) => {
    const newTime = `${moment(dateIso).format('YYYY-MM-DD hh:mm:ss')} ${fromAbbr}`;
    updateSlot({
      from: moment(newTime).toISOString(),
      to: slot.to
    });
  };

  const handleToTime = (dateIso) => {
    const newTime = `${moment(dateIso).format('YYYY-MM-DD hh:mm:ss')} ${toAbbr}`;
    updateSlot({
      from: slot.from,
      to: moment(newTime).toISOString()
    });
  };

  return (
    <Stack
      sx={{
        '&:not(:last-child)': {
          mb: 1
        }
      }}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Stack direction="row" flex={0.8} alignItems="center" justifyContent="space-between">
        <Stack direction="row">
          <TimePicker
            selectedTime={slot.from}
            onChange={handleFromTime}
            disableTimeArray={otherSelectedFromTime}
          />
          <TimeNotation value={fromAbbr} onChange={setFromAbbr} />
        </Stack>
        <Typography mx={{ xs: 1, md: 2 }}>-</Typography>
        <Stack direction="row">
          <TimePicker
            selectedTime={slot.to}
            onChange={handleToTime}
            disableTimeArray={otherSelectedToTime}
          />
          <TimeNotation value={toAbbr} onChange={setToAbbr} />
        </Stack>
      </Stack>
      {removeBtn && (
        <IconButton onClick={() => removeSlot(slot._id)} color="error">
          <Iconify icon="fluent:delete-12-regular" />
        </IconButton>
      )}
      {showAddBtn && (
        <IconButton onClick={() => addSlot()} color="success">
          <Iconify icon="carbon:add" />
        </IconButton>
      )}
    </Stack>
  );
}

TimeRow.propTypes = {
  slot: PropTypes.object,
  removeBtn: PropTypes.bool,
  addSlot: PropTypes.func,
  removeSlot: PropTypes.func,
  showAddBtn: PropTypes.bool,
  updateSlot: PropTypes.func,
  otherSelectedFromTime: PropTypes.array,
  otherSelectedToTime: PropTypes.array
};
